import { initializeApp, getApps } from "firebase/app";
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { getFirestore, collection, query, where, getDocs, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Firebase yapılandırması
const firebaseConfig = {
  apiKey: "AIzaSyAXV9hxt3AwQPEnHMF4LwDmM412MAxZ36U",
  authDomain: "ustmas-panel.firebaseapp.com",
  projectId: "ustmas-panel",
  storageBucket: "ustmas-panel.firebasestorage.app",
  messagingSenderId: "212536895603",
  appId: "1:212536895603:web:90819c4bc3eb2b8be12206"
};

// Uygulama başlatılıyor
const appName = "filo-takip";
const app = getApps().find((existingApp) => existingApp.name === appName) || initializeApp(firebaseConfig, appName);

// Auth, Firestore ve Storage bağlantıları
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app, "gs://ustmas-panel.firebasestorage.app");


// ✅ Yeni kullanıcı oluşturma
export const createNewUser = async (email, password, role) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;
    // Rol Firestore'da kullanıcıya atanabilir (tercihe bağlı)
    return { success: true, user };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// ✅ Kullanıcıyı pasifleştirme (Firestore'da "active: false" yapılır)
export const deactivateUser = async (email) => {
  try {
    const q = query(collection(db, "users"), where("email", "==", email));
    const snapshot = await getDocs(q);
    if (snapshot.empty) return { success: false, error: "Kullanıcı bulunamadı" };

    const userDoc = snapshot.docs[0];
    await updateDoc(userDoc.ref, { active: false });
    return { success: true };
  } catch (err) {
    return { success: false, error: err.message };
  }
};
